// @core/api/endpoints/chat/create_chat_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ChatPolicyResponse,
  CreateChatPolicyRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Create chat policy
 * Creates a chat policy for a scope entity (organization, team, department). Configures default conversation settings, limits, and feature toggles.
 */
export async function CreateChatPolicy(
  data: CreateChatPolicyRequest,
  options?: RequestOptions
): Promise<ChatPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/chat-policies`;
  const requestOptions = options;
  return client.post<ChatPolicyResponse>(requestPath, data, requestOptions);
}
